import React from 'react';
import {useTranslation} from 'react-i18next';
import {BackIcon} from 'components/common/icons';
import style from './SubHeader.module.scss';

export default function SubHeader({showBackButton, toBack, backText, title}) {
    const {t} = useTranslation();

    return (
        <div className={style.subHeader}>
            {showBackButton && (
                <div className={style.backContainer} onClick={toBack}>
                    <BackIcon className={style.backButton} />
                    {backText || t(`page.back`)}
                </div>
            )}
            {title}
        </div>
    );
}
